import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { hideNotification } from "../redux/slices/notificationSlice";
const TYPE_BG = {
  success: "#16a34a",
  error: "#b40a0a",
  info: "#2563eb",
};

export default function Notification() {
  const dispatch = useDispatch();
  const { message, type, visible } = useSelector((state) => state.notification);
  const [progress, setProgress] = useState(100);
  const DURATION = 3000;

  useEffect(() => {
    if (visible) {
      setProgress(100);
      const started = performance.now();
      let frame = null;
      const timer = setTimeout(() => dispatch(hideNotification()), DURATION);
      const tick = () => {
        const elapsed = performance.now() - started;
        const pct = Math.max(0, 100 - (elapsed / DURATION) * 100);
        setProgress(pct);
        if (pct > 0) frame = requestAnimationFrame(tick);
      };
      frame = requestAnimationFrame(tick);
      return () => {
        clearTimeout(timer);
        if (frame) cancelAnimationFrame(frame);
      };
    }
  }, [visible, message, type, dispatch]);

  if (!visible) return null;

  const base =
    "fixed bottom-4 right-4 px-4 py-2.5 rounded-lg shadow-md control-text z-50 border";

  return (
    <div
      className={base}
      style={{
        backgroundColor: TYPE_BG[type] || TYPE_BG.info,
        color: "#ffffff",
        borderColor: TYPE_BG[type] || TYPE_BG.info,
        minWidth: "240px",
      }}
    >
      <div className="flex items-start gap-2">
        <span className="leading-snug">{message}</span>
      </div>
      <div className="mt-2 h-1 rounded-full bg-white/25 overflow-hidden" aria-hidden>
        <div
          className="h-full bg-white/80 origin-left"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}
